import type { FC } from 'react'
import { emptyImagePlaceholder } from 'constants/image'
import { Link } from 'components/ui'
import type { PostCardProps } from '.'
import s from './post-card.module.css'

const PostCard: FC<PostCardProps> = ({ post }) => {
  const { slug, title, categories, description, image, createdAt } = post

  const emptyImage = image?.url.charAt(image?.url.length - 1) === "/" || !image?.url;

  return (
    <Link href={`/blog/${slug}`} className={s.root}>
      <div className={s.image}>
        <img
          src={emptyImage ? "/assets/images/default.png" : image?.url}
          alt={title}
          onError={(e) => (e.currentTarget.src = "/assets/images/default.png")}
        />
      </div>
      <div>
        {(categories && Array.isArray(categories))
          && categories.length > 0
          && categories.map(({ name }) => (
          <span className={s.tag}>{name}</span>
        ))}
        <span className={s.created}>{createdAt}</span>
      </div>
      <h3 className={s.title}>{title}</h3>
      <div className={s.description}>{description}</div>
    </Link>
  )
}

export default PostCard
